import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Fieldset,
  Legend,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import Select from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect, withRouter } from "react-router-dom";
import apiResponse from "../../../../../services/apiResponse";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/cp3kService";
import CreateBloc from "../Blocs/CreateBloc";

class CreateModal extends Component {
  createBloc = new CreateBloc();
  timer;
  source;
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: null,
      workUnitOption: [],
      maritalStatusOption: [],
      bankOption: [],
      religionOption: [],
      positionOption: [],
      rankOption: [],
      educationOption: [],
      birthNational: "Dalam Negeri",
      birthOptionCountry: [],
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthSelectedCity: "",
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
    };
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };
  reformatPositionOptions = (raw, name, grade, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[name] + " (Grade " + data[grade] + ")";
      newObj["value"] = data[value];

      return newObj;
    });
  };

  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
        birthNational: selected,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        birthSelectedProvince: "",
        birthSelectedCity: "",
        birthNational: selected,
      });
    }
  };

  handleBirthSelectProvince = (birthSelectedProvince) => {
    let selected = birthSelectedProvince.value;
    this.getBirthCityByProvince(selected);
  };

  getBirthCityByProvince = (province_uuid) => {
    this.setState({ birthSelectedCity: "" });
    this.createBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        period_uuid: this.props.periodUuid,
        uuid: this.props.detailUuid,
        ...values,
      },
      confirm: true,
    });
  };

  loadEducation = async () => {
    this.setState({ loadingEducation: true });
    await this.createBloc.fetchEducation({ is_default: 1 });
  };

  loadRank = async () => {
    this.setState({ loadingRank: true });
    await this.createBloc.fetchRank();
  };

  loadWorkUnit = async () => {
    this.setState({ loadingWorkUnit: true });
    await this.createBloc.fetchWorkUnit();
  };

  loadMarital = async () => {
    this.setState({ loadingMarital: true });
    await this.createBloc.fetchMaritalStatus();
  };

  loadBank = async () => {
    this.setState({ loadingBank: true });
    await this.createBloc.fetchBank();
  };

  loadReligion = async () => {
    this.setState({ loadingReligion: true });
    await this.createBloc.fetchReligion();
  };

  loadPosition = async (uuid) => {
    this.setState({ loadingPosition: true });
    await this.createBloc.fetchPosition({
      is_internal: 1,
    });
  };

  loadRegionCountry = async (uuid) => {
    this.setState({ loadingRegionCountry: true });
    await this.createBloc.fetchRegionCountry({ type: 1 });
  };

  loadRegionProvince = async (uuid) => {
    this.setState({ loadingRegionProvince: true });
    await this.createBloc.fetchRegionProvince({ type: 2 });
  };

  loadDetail = async (uuid) => {
    const query = {
      uuid: uuid,
    };
    await this.createBloc.fetchDetailCandidate(query);
  };

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
    // if (this.props.uuid === '') {
    //     await this.createBloc.fetchCreate(this.state.dataForm)
    // } else {
    //     await this.createBloc.fetchCreateDetail(this.state.dataForm)
    // }
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadEducation();
    this.loadWorkUnit();
    this.loadPosition();
    this.loadRank();
    this.loadRegionCountry();
    this.loadRegionProvince();
    this.loadMarital();
    this.loadBank();
    this.loadReligion();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          //this.props.setUuid(result.data.response.employee_transfer_uuid)
          //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
          this.setState({
            loading: false,
            success: true,
          });
          this.props.toggle();
          this.props.handleReload();
          this.props.setDetailUuid();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          this.props.toggle();
          this.props.handleReload();
          this.props.setDetailUuid();
          break;
        default:
          break;
      }
    });

    this.createBloc.detailCandidateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let resp = result.data.response;

          if (resp != null) {
            this.setState({
              loading: false,
              detail: resp,

              birthOptionCity: [
                {
                  label: resp.cp3k_candidate_place_of_birth_city_name,
                  value: resp.cp3k_candidate_place_of_birth_city_uuid,
                },
              ],
              birthNational: resp.cp3k_candidate_place_of_birth_national,
              birthSelectedCountry:
                resp.cp3k_candidate_place_of_birth_country_uuid,
              birthSelectedProvince:
                resp.cp3k_candidate_place_of_birth_province_uuid,
              birthSelectedCity: resp.cp3k_candidate_place_of_birth_city_uuid,
            });
          } else {
            this.setState({
              loading: false,
              detail: null,
              birthNational: "Dalam Negeri",
              birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
              birthSelectedProvince: "",
              birthSelectedCity: "",
            });
          }
          this.props.toggle();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.educationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            educationOption: this.reformatOptions(
              result.data.response.result,
              "education_name",
              "education_uuid"
            ),
            loadingEducation: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            rankOption: result.data.response.result.map(function (data) {
              var newObj = {};
              newObj["label"] = `${data.rank_name}`; ////(${data.rank_group_room})`;
              newObj["value"] = data.rank_uuid;

              return newObj;
            }),
            loadingRank: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            workUnitOption: this.reformatOptions(
              result.data.response.result,
              "work_unit_name_tabs",
              "work_unit_uuid"
            ),
            loadingWorkUnit: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.maritalStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            maritalStatusOption: result.data.response.result,
            loadingMarital: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.bankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            bankOption: result.data.response.result,
            loadingBank: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.religionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            religionOption: result.data.response.result,
            loadingReligion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.positionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            positionOption: this.reformatPositionOptions(
              result.data.response.result,
              "position_name",
              "position_grade", //"position_grade_name",
              "position_uuid"
            ),
            loadingPosition: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            birthOptionCountry: this.reformatOptions(
              result.data.response.result,
              "region_name",
              "region_uuid"
            ),
            loadingRegion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            birthOptionProvince: this.reformatOptions(
              result.data.response.result,
              "region_name",
              "region_uuid"
            ),
            loadingRegion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            birthOptionCity: this.reformatOptions(
              result.data.response.result,
              "region_name",
              "region_uuid"
            ),
            loadingRegion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.detailCandidateChannel?.unsubscribe();
    this.createBloc.educationChannel?.unsubscribe();
    this.createBloc.rankChannel?.unsubscribe();
    this.createBloc.workUnitChannel?.unsubscribe();
    this.createBloc.maritalStatusChannel?.unsubscribe();
    this.createBloc.bankChannel?.unsubscribe();
    this.createBloc.religionChannel?.unsubscribe();
    this.createBloc.positionChannel?.unsubscribe();
    this.createBloc.regionCountryChannel?.unsubscribe();
    this.createBloc.regionProvinceChannel?.unsubscribe();
    this.createBloc.regionCityChannel?.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.modal !== this.props.modal) {
      if (this.props.modal == false) {
        this.setState({
          dataForm: null,
          detail: null,
          birthNational: "Dalam Negeri",
          birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
          birthSelectedProvince: "",
          birthSelectedCity: "",
        });
      }
    }

    if (prevProps.detailUuid !== this.props.detailUuid) {
      if (this.props.detailUuid) {
        this.loadDetail(this.props.detailUuid);
      }
    }
  }

  render() {
    // const defaultDateFormat = this.state.detail?.cp3k_bkn_confirmation_date; // Assuming this holds the date in "yyyy-mm-dd" format

    // // Convert date format using moment.js
    // const formattedDate = moment(defaultDateFormat).format('DD-MM-YYYY');
    return (
      <Fragment>
        <Modal isOpen={this.props.modal} size="xl" toggle={this.props.toggle}>
          <ModalHeader
            toggle={() => {
              this.props.toggle();
              this.props.setDetailUuid();
            }}
          >
            Input Anggota PPPK
          </ModalHeader>
          <ModalBody>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Penetapan NIP BKN <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <AvField
                    name="cp3k_bkn_confirmation_number"
                    placeholder="NIP BKN"
                    errorMessage="Masukkan NIP BKN"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_bkn_confirmation_number}
                    validate={{
                      required: { value: true },
                      // minLength: {
                      //   value: 18,
                      //   errorMessage: "Minimum NIP 18 digits",
                      // },
                      // maxLength: {
                      //   value: 18,
                      //   errorMessage: "Maximum NIP 18 digits",
                      // },
                    }}
                  />
                </Col>
                <Col md="3">
                  <AvField
                    name="cp3k_bkn_confirmation_date"
                    placeholder="Tanggal"
                    errorMessage="Masukkan Tanggal"
                    type="date"
                    className="form-control"
                    value={this.state.detail?.cp3k_bkn_confirmation_date}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <hr />

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nama <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_name"
                    placeholder="Nama"
                    errorMessage="Masukkan Nama"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_name}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Gelar (Depan | Belakang)
                </Label>
                <Col md="2">
                  <AvField
                    name="cp3k_candidate_front_title"
                    placeholder="Gelar Depan"
                    errorMessage="Masukkan Gelar Depan"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_front_title}
                    validate={{ required: { value: false } }}
                  />
                </Col>
                <Col md="2">
                  <AvField
                    name="cp3k_candidate_end_title"
                    placeholder="Gelar Belakang"
                    errorMessage="Masukkan Gelar Belakang"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_end_title}
                    validate={{ required: { value: false } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Email BKPM<span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_email"
                    placeholder="Email BKPM"
                    errorMessage="Masukkan Email BKPM"
                    type="email"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_email}
                    validate={{
                      required: { value: true },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nomor HP <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_phone_number"
                    placeholder="Nomor HP"
                    errorMessage="Masukkan Nomor HPP"
                    type="number"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_phone_number}
                    validate={{
                      required: { value: true },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  NIK <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_nik"
                    placeholder="NIK"
                    errorMessage="Masukkan NIK"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_nik}
                    validate={{
                      required: { value: true },
                      minLength: {
                        value: 16,
                        errorMessage: "Minimum NIP 16 digits",
                      },
                      maxLength: {
                        value: 16,
                        errorMessage: "Maximum NIP 16 digits",
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nomor KK <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_familiy_card_number"
                    placeholder="Nomor KK"
                    errorMessage="Masukkan Nomor KK"
                    type="text"
                    className="form-control"
                    value={
                      this.state.detail?.cp3k_candidate_familiy_card_number
                    }
                    validate={{
                      required: { value: true },
                      // minLength: {
                      //   value: 16,
                      //   errorMessage: "Minimum NIP 16 digits",
                      // },
                      // maxLength: {
                      //   value: 16,
                      //   errorMessage: "Maximum NIP 16 digits",
                      // },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nomor NPWP <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_npwp_number"
                    placeholder="Nomor NPWP"
                    errorMessage="Masukkan Nomor NPWP"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_npwp_number}
                    validate={{
                      required: { value: true },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  NIP <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_nip"
                    placeholder="NIP"
                    errorMessage="Masukkan NIP"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_nip}
                    validate={{
                      required: { value: true },
                      minLength: {
                        value: 18,
                        errorMessage: "Minimum NIP 18 digits",
                      },
                      maxLength: {
                        value: 18,
                        errorMessage: "Maximum NIP 18 digits",
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Tempat Lahir <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_place_of_birth_national"
                    errorMessage="Pilih Dalam / Luar Negeri"
                    placeholder="Pilih Dalam / Luar Negeri"
                    options={[
                      { label: "Dalam Negeri", value: "Dalam Negeri" },
                      { label: "Luar Negeri", value: "Luar Negeri" },
                    ]}
                    onChange={this.handleBirthSelectNationality}
                    defaultValue={this.state.birthNational}
                    validate={{ required: { value: true } }}
                  />
                </Col>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_place_of_birth_country_uuid"
                    errorMessage="Negara"
                    placeholder="Negara"
                    options={this.state.birthOptionCountry}
                    onChange={(opt) =>
                      this.setState({ birthSelectedCountry: opt.value })
                    }
                    defaultValue={this.state.birthSelectedCountry}
                    validate={{ required: { value: true } }}
                    isDisabled={
                      this.state.birthNational == "Dalam Negeri" ? true : false
                    }
                  />
                </Col>
              </Row>

              <Row
                className="mb-3"
                style={
                  this.state.birthNational == "Dalam Negeri"
                    ? {}
                    : { display: "none" }
                }
              >
                <Label className="col-md-3 col-form-label"></Label>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_place_of_birth_province_uuid"
                    errorMessage="Pilih Provinsi"
                    placeholder="Provinsi"
                    options={this.state.birthOptionProvince}
                    onChange={this.handleBirthSelectProvince}
                    defaultValue={this.state.birthSelectedProvince}
                    validate={{
                      required: {
                        value:
                          this.state.birthNational == "Dalam Negeri"
                            ? true
                            : false,
                      },
                    }}
                  />
                </Col>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_place_of_birth_city_uuid"
                    errorMessage="Pilih Kota"
                    placeholder="Kota"
                    options={this.state.birthOptionCity}
                    //onChange={opt => this.setState({ type: opt.value })}
                    defaultValue={this.state.birthSelectedCity}
                    validate={{
                      required: {
                        value:
                          this.state.birthNational == "Dalam Negeri"
                            ? true
                            : false,
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row
                className="mb-3"
                style={
                  this.state.birthNational == "Dalam Negeri"
                    ? { display: "none" }
                    : {}
                }
              >
                <Label className="col-md-3 col-form-label"></Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_place_of_birth_city_text"
                    placeholder="Kota..."
                    type="text"
                    errorMessage="Masukkan Kota"
                    className="form-control"
                    value={
                      this.state.detail?.cp3k_candidate_place_of_birth_city_text
                    }
                    validate={{
                      required: {
                        value:
                          this.state.birthNational == "Dalam Negeri"
                            ? false
                            : true,
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Kode Pos <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_postal_code"
                    placeholder="Kode Pos"
                    errorMessage="Masukkan Kode Pos"
                    // type="number"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_postal_code}
                    validate={{
                      required: { value: true },
                      minLength: {
                        value: 5,
                        errorMessage: "Minimum Kode Pos 5 digits",
                      },
                      maxLength: {
                        value: 10,
                        errorMessage: "Maximum Kode Pos 10 digits",
                      },
                    }}
                    // validate={{
                    //   required: { value: true },
                    // }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Alamat <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_address"
                    placeholder="Alamat"
                    errorMessage="Masukkan Alamat"
                    type="textarea"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_address}
                    validate={{
                      required: { value: true },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Tanggal Lahir <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <AvField
                    name="cp3k_candidate_date_of_birth"
                    placeholder="Tanggal Lahir"
                    errorMessage="Masukkan Tanggal Lahir"
                    type="date"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_date_of_birth}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jenis Kelamin <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_gender"
                    errorMessage="Pilih Jenis Kelamin"
                    placeholder="Pilih Jenis Kelamin"
                    options={[
                      { label: "Laki-laki", value: "L" },
                      { label: "Perempuan", value: "P" },
                    ]}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={this.state.detail?.cp3k_candidate_gender}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Status Kawin <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cp3k_candidate_marital_status_uuid"
                    errorMessage="Pilih Status Kawin"
                    placeholder="Pilih Status Kawin"
                    options={this.state.maritalStatusOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cp3k_candidate_marital_status_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Pendidikan Terakhir <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_last_education_uuid"
                    errorMessage="Pilih Pendidikan Terakhir"
                    placeholder="Pilih Pendidikan Terakhir"
                    options={this.state.educationOption}
                    //onChange={opt => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cp3k_candidate_last_education_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
                <Col md="3">
                  <AvField
                    name="cp3k_candidate_last_education_major"
                    placeholder="Program Studi / Jurusan"
                    errorMessage="Masukkan Program Studi"
                    type="text"
                    className="form-control"
                    value={
                      this.state.detail?.cp3k_candidate_last_education_major
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Golongan <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cp3k_candidate_rank_uuid"
                    errorMessage="Pilih Golongan"
                    placeholder="Pilih Golongan"
                    options={this.state.rankOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={this.state.detail?.cp3k_candidate_rank_uuid}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cp3k_candidate_position_uuid"
                    errorMessage="Pilih Jabatan"
                    placeholder="Pilih Jabatan"
                    options={this.state.positionOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cp3k_candidate_position_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Golongan <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_rank_name"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_name}
                  />
                  <AvField
                    name="cp3k_candidate_rank_uuid"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_name}
                  />
                </Col>
              </Row> */}

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Unit Kerja <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cp3k_candidate_work_unit_uuid"
                    errorMessage="Pilih Unit Kerja"
                    placeholder="Pilih Unit Kerja"
                    options={this.state.workUnitOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cp3k_candidate_work_unit_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Bank <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cp3k_candidate_account_bank_uuid"
                    errorMessage="Pilih Bank"
                    placeholder="Pilih Bank"
                    options={this.state.bankOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cp3k_candidate_account_bank_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nomor Rekening <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_account_bank_number"
                    placeholder="Nomor Rekening"
                    errorMessage="Masukkan Nomor Rekening"
                    type="text"
                    className="form-control"
                    value={
                      this.state.detail?.cp3k_candidate_account_bank_number
                    }
                    validate={{
                      required: { value: true },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nama Rekening <span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_account_name"
                    placeholder="Nama Rekening"
                    errorMessage="Masukkan Nama Rekening"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_account_name}
                    validate={{
                      required: { value: true },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Agama <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cp3k_candidate_religion_uuid"
                    errorMessage="Pilih Agama"
                    placeholder="Pilih Agama"
                    options={this.state.religionOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cp3k_candidate_religion_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Enroll Number<span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cp3k_candidate_enroll_number"
                    placeholder="Enroll Number"
                    errorMessage="Masukkan Enroll Number"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cp3k_candidate_enroll_number}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => {
                    this.props.toggle();
                    this.props.setDetailUuid("");
                  }}
                >
                  Cancel
                </Button>{" "}
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </AvForm>
          </ModalBody>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default withRouter(CreateModal);
